<template>
  <div>
    <input type="text" v-model="selfValue" pattern="[0-9]*" v-on:keyup.enter="submit()" readonly>
    <div class="virtual-numeric-keyboard bg-light rounded border p-3">
      <button
        v-for="key in keys"
        :key="key"
        @click="press(key)"
        class="btn-keyboard"
      >{{ key }}</button>
      <button class="btn-keyboard delete" @click="clear('all')">❌</button>
      <button class="btn-keyboard" @click="press('0')">0</button>
      <button class="btn-keyboard submit" @click="submit()">👍🏼</button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      keys: [1,2,3,4,5,6,7,8,9],
    };
  },
  methods: {
    press(key) {
      this.selfValue = `${this.selfValue}${key}`;
    },
    clear(type) {
      if (type === 'all') this.selfValue = '';
      else this.selfValue = this.value.substring(0, this.value.length - 1);
    },
    submit() {
        this.$emit('submit', this.value)
    }
  },
  watch: {
    value() {
      //this.$emit('input', this.value)
    }
  },
  computed: {
    selfValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style scoped>
.virtual-numeric-keyboard {
  max-width: 300px;
  margin: 5px auto;
  display: grid;
  grid-template-columns: auto auto auto;
  grid-gap: 1px;
}

.virtual-numeric-keyboard .btn {
  font-weight: bold;
}

.btn-keyboard {
  font-size: 2rem;
  padding: 0.5rem 1rem;
  color: white;
  background: rgb(0, 102, 128);
  border: none;
}

.btn-keyboard.submit {
  background: green;
}

.btn-keyboard.delete {
  background: rgb(161, 48, 48);
}

.btn-keyboard:hover {
  cursor: pointer;
}

.btn-keyboard.disabled {
  opacity: 0.25;
  cursor: not-allowed;
}

input {
  margin-top: 20px;
  width: 258px;
  font-size: 3rem;
  padding: 1rem;
  text-align: center;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number],
input[type=number]:focus {
  -webkit-appearance: none;
  -moz-appearance: textfield;
  border: none;
  outline: none;
}
</style>